export const DEFAULT_LOCALE = 'de';
export const SUPPORTED_LOCALES = ['de', 'pl', 'en'];
export const LANG_QUERY_PARAM = 'lang';

export const isSupportedLocale = (locale) => SUPPORTED_LOCALES.includes(locale);

/**
 * Reads the lang query param from a search string.
 *
 * @param {string} search - Search string, e.g. `?q=foo&lang=en`.
 * @returns {string|null} - The raw param value, or null when it is missing.
 */
export const getLangParam = (search) =>
  new URLSearchParams(search).get(LANG_QUERY_PARAM);

/**
 * Sets the lang query param in a search string.
 * Other params are kept verbatim, so encodings used by e.g. search-ui survive.
 *
 * @param {string} search - Search string, with or without the leading `?`.
 * @param {string} locale - Locale to set.
 * @returns {string} - Search string with a leading `?`.
 */
export const withLangParam = (search, locale) => {
  const otherParams = search
    .replace(/^\?/, '')
    .split('&')
    .filter((pair) => pair && pair.split('=')[0] !== LANG_QUERY_PARAM);

  return `?${[...otherParams, `${LANG_QUERY_PARAM}=${locale}`].join('&')}`;
};
